import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconCarpetedFloors: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22 10c0 .6-.4 1-1 1h-1v2h1c.6 0 1 .4 1 1s-.4 1-1 1h-1v2h1c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1h1v-2H3c-.6 0-1-.4-1-1s.4-1 1-1h1v-2H3c-.6 0-1-.4-1-1s.4-1 1-1h1V7H3c-.6 0-1-.4-1-1s.4-1 1-1h18c.6 0 1 .4 1 1s-.4 1-1 1h-1v2h1c.6 0 1 .4 1 1zm-4-3H6v10h12V7zm-6.7 1.3c.4-.4 1-.4 1.4 0l3 3c.4.4.4 1 0 1.4l-3 3c-.2.2-.4.3-.7.3-.3 0-.5-.1-.7-.3l-3-3c-.4-.4-.4-1 0-1.4l3-3zm-.9 3.7l1.6 1.6 1.6-1.6-1.6-1.6-1.6 1.6z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
